import { Modal, ModalTitleProps } from '@mantine/core';
import clsx from 'clsx';
import { forwardRef } from 'react';

export type ModalFormTitleProps = ModalTitleProps;

export const createModalFormTitle = () => {
	const ModalFormTitle = forwardRef<HTMLDivElement, ModalFormTitleProps>(
		({ className, children, ...props }, ref) => (
			<Modal.Title
				ref={ref}
				className={clsx('modal-form-title', className)}
				{...props}
			>
				{children}
			</Modal.Title>
		),
	);

	return ModalFormTitle;
};
